import { PublicitatContext } from '../../context/PublicitatProvider';
import { useContext } from 'react';

export const usePublicitat = () => {
    const { setupPubliFinished, hasTopBannerPublicitat } = useContext(PublicitatContext);

    return { setupPubliFinished, hasTopBannerPublicitat };
};
